import type { User } from 'oidc-client-ts'
import type { Scopes } from './scopes/enum'

export interface UserGrant {
  orgId: string
  projectId: string
  userId: string
  roles: string[]
  orgName: string
  grantId: string
  details: {
    sequence: string
    creationDate: string
    changeDate: string
    resourceOwner: string
  }
  orgDomain: string
  projectName: string
  roleKeys: string[]
  userType: string
}

export interface Projects {
  name: string
  url?: URL
  org: string
}

export interface PrivacySettings {
  tosLink: string
  privacyLink: string
  isDefault: boolean
  helpLink: string
  supportEmail: string
  docsLink: string
  customLink: string
  customLinkText: string
}

export enum ThemeMode {
  light = 'THEME_MODE_LIGHT',
  dark = 'THEME_MODE_DARK',
  auto = 'THEME_MODE_AUTO',
  unspecified = 'THEME_MODE_UNSPECIFIED',
}

export interface Theming {
  iconUrlDark: string
  iconUrl: string
  logoUrl: string
  logoUrlDark: string
  backgroundColorDark: string
  primaryColorDark: string
  fontColorDark: string
  warnColorDark: string

  backgroundColor: string
  primaryColor: string
  fontColor: string
  warnColor: string

  themeMode: ThemeMode
}

export type UserWithProfile = User & {
  profile: {
    [Scopes.ProjectRoles]: { [key: string]: any }
    [Scopes.ResourceOwnerId]: string
    [Scopes.ResourceOwnerName]: string
    [Scopes.ResourceOwnerPrimaryDomain]: string
  }
}
